<template>
  <SegmentedSwitch
    class="report-mode-switcher"
    :model-value="modelValue"
    :options="modes"
    label="Statistics sections"
    :tab-id="(mode) => `report-mode-${mode}`"
    :panel-id="(mode) => `report-panel-${mode}`"
    @update:model-value="selectMode"
  >
    <template #option="{ option }">
      <span>{{ option.label }}</span>
      <NotificationBadge
        v-if="option.value === 'work-permissions'"
        :count="attentionCount"
        singular-label="supplier requires follow-up"
        plural-label="suppliers require follow-up"
      />
    </template>
  </SegmentedSwitch>
</template>

<script setup>
import { computed } from 'vue';
import NotificationBadge from '@/components/NotificationBadge.vue';
import SegmentedSwitch from '@/components/common/SegmentedSwitch.vue';
import { useWorkPermissionsReportsStore } from '@/stores/workPermissionsReports';

const modes = [
  { value: 'analytics', label: 'Analytics' },
  { value: 'work-permissions', label: 'Work permissions' },
  { value: 'documents-status', label: 'Documents status' },
];

const props = defineProps({
  modelValue: {
    type: String,
    default: 'analytics',
  },
});

const emit = defineEmits(['update:modelValue']);
const workPermissionsReportsStore = useWorkPermissionsReportsStore();
const attentionCount = computed(() => workPermissionsReportsStore.attentionCount);

const selectMode = (mode) => {
  if (!mode || props.modelValue === mode) return;
  emit('update:modelValue', mode);
};
</script>
